import type { FunctionComponentWithRef } from "react";
import { graphql, useFragment } from "react-relay";

import { withHighlightedHeadline } from "scmp-app/components/content/content-item-render/highlight/hoc";
import { LinkHighlightArea } from "scmp-app/components/content/content-item-render/highlight/styles";
import { useContentItemProviders } from "scmp-app/components/content/content-item-render/hooks";
import type { ContentItemRenderVariantProps } from "scmp-app/components/content/content-item-render/types";
import type { plusInteractivesContentItemContent$key } from "scmp-app/queries/__generated__/plusInteractivesContentItemContent.graphql";

import { Container, ContentLink, Cover, CoverLink, Header, Headline } from "./styles";

export type Props = ContentItemRenderVariantProps & {
  onClick?: () => void;
  reference: plusInteractivesContentItemContent$key;
};

export const Component: FunctionComponentWithRef<Props, HTMLDivElement> = ({
  className,
  onClick,
  ref,
  reference,
}) => {
  const entity = useFragment(
    graphql`
      fragment plusInteractivesContentItemContent on Content {
        __typename
        ...entityLink
        ...helpersCheckIsPlusArticle
        ...hooksContentItemProvidersContent
          @arguments(withHeadline: true, withCoverImage: true, withCoverImageSize540x360: true)
      }
    `,
    reference,
  );

  const providers = useContentItemProviders(entity);

  return (
    <Container className={className} ref={ref}>
      <Cover>
        <CoverLink onClick={onClick}>
          {providers.coverImage({
            responsiveVariants: {
              desktopUp: "size540x360",
              mobileUp: "size540x360",
              tabletUp: "size540x360",
            },
          })}
        </CoverLink>
      </Cover>
      <Header>
        <LinkHighlightArea>
          <ContentLink onClick={onClick}>
            <Headline>
              {providers.headline({
                hideTooltip: true,
                preferSocialHeadline: true,
              })}
            </Headline>
          </ContentLink>
        </LinkHighlightArea>
      </Header>
    </Container>
  );
};

Component.displayName = "ContentItemPlusInteractives";
export const ContentItemPlusInteractives = withHighlightedHeadline(Component);
